import { ChangeDetectionStrategy, Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

@Component({
  selector: 'wz-icon',
  templateUrl: './icons.component.html',
  styleUrls: ['./icons.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class IconsComponent implements OnInit {
  @Input() icons: string[] = []
  @Input() name: any = '';
  @Input() customClass: string = 'wz-icon';
  @Input() iconClass: string = 'icon-24';
  @Input() type: string = 'default';
  @Input() active: boolean = false;
  @Output() iconName: EventEmitter<any> = new EventEmitter;

  iconClick(name:any){
    this.iconName.emit(name)
  }

  ngOnInit(): void {
    
  }

  trackByItem(index: number, item: string): string | number {
    return item ?? index;
  }
}
